import { render, staticRenderFns } from "./Compose.vue?vue&type=template&id=0ca76156&scoped=true"
import script from "./Compose.vue?vue&type=script&lang=js"
export * from "./Compose.vue?vue&type=script&lang=js"
import style0 from "./Compose.vue?vue&type=style&index=0&id=0ca76156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca76156",
  null
  
)

export default component.exports